import { createQueryKeys } from '../../factories';

const PUBLIC_ENV_NAMESPACE = ['public', 'env'];
const MEMBER_ENV_NAMESPACE = ['member', 'env'];

export const publicEnvQueryKeyFactory = createQueryKeys(PUBLIC_ENV_NAMESPACE);
export const memberEnvQueryKeyFactory = createQueryKeys(MEMBER_ENV_NAMESPACE);
